import { getHostname } from './hostname';

export const isProduction = () => /\fixly.pl/.test(getHostname());
export const isStaging = () => !isProduction();
